import { type NextProfitsResponse, nextProfitsResponseSchema } from 'investments/common/definitions'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { type UseQueryRequestOptions, useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

async function fetchMarketNextProfits({ accountId }: { accountId: string }) {
  const { data } = await httpClientBanking({
    url: `/investments/accounts/${accountId}/storefront/next_profits`,
    method: 'GET'
  })

  return nextProfitsResponseSchema.parse(data)
}

export function getUseFetchMarketNextProfitsKey(accountId: string) {
  return ['useFetchMarketNextProfits', accountId] as const
}

export function useFetchMarketNextProfits({
  accountId,
  options
}: {
  accountId: string
  options?: UseQueryRequestOptions<NextProfitsResponse, unknown, true>
}) {
  return useQueryRequest<NextProfitsResponse, unknown, true>(
    getUseFetchMarketNextProfitsKey(accountId),
    () => fetchMarketNextProfits({ accountId }),
    {
      suspense: false,
      retry: false,
      ...options
    }
  )
}
